module.exports = __webpack_public_path__ + "img/行企动态.9492d2da.svg";